import posthog, { Platform, Environment } from '@leyan/lytics';
import { getDeviceId } from 'lib/deviceId';
import { isMasterOnline, isQuickChat, isSiteGiant, isTfsoftware } from 'productLine';
import { getLeYanBotHost } from 'services/api/leyanBotHost';
import chatttSDK from 'services/chattt';
import * as Sentry from '@sentry/react';
import { setLoggerBaseContext } from 'services/logger';

export interface TrackerInitParams {
  orgId?: number;
  id?: string;
  name?: string;
  roles?: Assistant.Role[];
}

let inited = false;
const getClientInfo = async () => {
  const ret = await chatttSDK?.app?.info?.();
  const version = await chatttSDK?.app?.getVersion();
  if (!ret && version) {
    return { version };
  }
  return ret || {};
};

export async function init(params: TrackerInitParams) {
  if (import.meta.env.DEV) {
    return;
  }
  const { orgId, id, name } = params;
  Sentry.setTags({
    orgId: orgId,
    userId: id,
    userName: name,
    pacakgeVersion: import.meta.env.VITE_VERSION,
  });

  if (!inited) {
    posthog.init(`${import.meta.env.VITE_PLATFORM}-${import.meta.env.VITE_NAME}`, {
      persistence: 'localStorage+cookie',
      autocapture: true,
      ip: true,
      api_host: import.meta.env.VITE_LYTICS_ENDPOINT as string,
    });
    inited = true;
  }
  const { channel, appId, version, deviceId: client_device_id, osVersion } = await getClientInfo();
  const intlDateOptions = Intl.DateTimeFormat().resolvedOptions();

  const { ip, countryCode, deviceId, channel: web_channel } = await getDeviceId();
  Sentry.setTag('deviceId', deviceId);

  const meta = {
    $device_id: deviceId,
    distinct_id: deviceId,
    app_name: isQuickChat
      ? 'quickchat'
      : isTfsoftware
      ? 'tfsoftware'
      : isSiteGiant
      ? 'sitegiant'
      : isMasterOnline
      ? 'masteronline'
      : import.meta.env.VITE_NAME!,
    app_platform: import.meta.env.VITE_PLATFORM! as Platform,
    app_version: import.meta.env.VITE_VERSION!,
    app_env: import.meta.env.VITE_ENV! as Environment,
    org_id: orgId?.toString() || '',
    user_id: id?.toString() || '',
    user_name: name?.toString() || '',
    ip: ip || '',
    timezone: intlDateOptions.timeZone,
    locale: intlDateOptions.locale,
    leyanbot_host: getLeYanBotHost(),
    country_code: countryCode || '',
    web_channel,
    // 客户端信息
    client_channel: channel || '',
    client_app_id: appId || '',
    client_version: version || 'web',
    client_device_id: client_device_id || '',
    client_os_version: osVersion || '',
  };

  setLoggerBaseContext(meta);

  posthog.register(meta);

  // 请求host上报
  if (countryCode) {
    const data = {
      countryCode,
      countryHost: getLeYanBotHost(),
    };
    posthog.capture('$requestHost', data);
  }
}
